import Backbone from 'backbone';
import AdminConstants from '../../constants/AdminConstants';
import { DOCUMENT_TYPES_KEY } from '../../constants/Documents';

const HIDDEN_COLUMN_STRING = 'EQUIPMENT_HIDDEN_COLS';

export default Backbone.Model.extend({
  initialize() {
    this.set('token', this.loadToken());
    this.set('refresh-token', this.loadRefreshToken());
    this.set('user', this.loadUser());
  },

  login(token, user) {
    const loginAtts = {
      token,
      user,
      error: null,
    };
    this.set(loginAtts);
    this.storeToken(token);
    this.storeUser(user);
  },

  logout() {
    const logoutAtts = {
      token: null,
      user: null,
      error: null,
    };
    const user = this.loadUser();
    if (user && user._id) {
      localStorage.setItem(
        `${user._id}${AdminConstants.accountAccessModal}`,
        JSON.stringify([]),
      );
    }
    this.removeLoginAs();
    this.clearCarrierPartner();
    this.clearShipperWarehouseRelationStatus();
    this.set(logoutAtts);
    this.clear();
  },

  error(msg) {
    if (msg) this.set('error', msg);
    return this.get('error');
  },

  getEquipmentUserColumnPreferences() {
    let hiddenColumns;
    try {
      hiddenColumns =
        JSON.parse(localStorage.getItem(HIDDEN_COLUMN_STRING)) || [];
    } catch (e) {
      hiddenColumns = [];
    }
    return hiddenColumns;
  },

  loadToken() {
    return localStorage.getItem(AdminConstants.token_key);
  },

  loadRefreshToken() {
    return localStorage.getItem(AdminConstants.refresh_token_key);
  },

  loadUser() {
    const userJSON = localStorage.getItem(AdminConstants.user_key);
    return JSON.parse(userJSON);
  },

  setEquipmentUserColumnPreferences(columns) {
    localStorage.setItem(HIDDEN_COLUMN_STRING, JSON.stringify(columns));
  },

  storeToken(token) {
    localStorage.setItem(AdminConstants.token_key, token);
  },

  storeUser(user) {
    const userJSON = JSON.stringify(user);
    this.set({ user });
    localStorage.setItem(AdminConstants.user_key, userJSON);
  },

  setLoginAs(user) {
    this.set('loginAs', user);
    localStorage.setItem('loginAs', user);
  },

  getShipperWarehouseRelationStatus() {
    return localStorage.getItem('shipperWarehouseRelationStatus');
  },

  setShipperWarehouseRelationStatus(status) {
    this.set('shipperWarehouseRelationStatus', status);
    localStorage.setItem('shipperWarehouseRelationStatus', status);
  },

  clearShipperWarehouseRelationStatus() {
    this.set('shipperWarehouseRelationStatus', null);
    localStorage.removeItem('shipperWarehouseRelationStatus');
  },

  setCarrierPartner(partnerId) {
    this.set('carrierPartner', partnerId);
    localStorage.setItem('carrierPartner', partnerId);
  },

  getCarrierPartner() {
    return localStorage.getItem('carrierPartner');
  },

  clearCarrierPartner() {
    this.set('carrierPartner', null);
    localStorage.removeItem('carrierPartner');
  },

  getLoginAs() {
    return localStorage.getItem('loginAs');
  },

  removeLoginAs() {
    localStorage.removeItem('loginAs');
  },

  removeSpecificDocTypes() {
    const DOC_TYPES_ENTITIES = ['ORDER', 'SHIPMENT'];
    DOC_TYPES_ENTITIES.forEach((type) =>
      localStorage.removeItem(`${type}_${DOCUMENT_TYPES_KEY}`),
    );
  },

  clear() {
    localStorage.removeItem(AdminConstants.token_key);
    localStorage.removeItem(AdminConstants.refresh_token_key);
    localStorage.removeItem(AdminConstants.user_key);
    this.removeSpecificDocTypes();
  },

  storeAccessAccountRequest(id, requestList) {
    const key = id + AdminConstants.accountAccessModal;
    const accountRequest = this.getAccessAccountRequest(id);
    if (accountRequest) {
      const toStore = requestList.concat(accountRequest);
      const value = JSON.stringify(toStore);
      localStorage.setItem(key, value);
    }
  },

  getAccessAccountRequest(id) {
    const key = id + AdminConstants.accountAccessModal;
    const value = localStorage.getItem(key);
    if (value) {
      return JSON.parse(value);
    }
    return [];
  },

  getLocalePreference(id) {
    const key = `${id}::language`;
    const value = localStorage.getItem(key);
    if (value) {
      return value;
    }
    return 'en';
  },

  setLocalePreference(id, languageCode) {
    localStorage.setItem(id, languageCode);
  },

  getLanguageCodeIdPreference(id) {
    const key = `${id}::languageCodeId`;
    const value = localStorage.getItem(key);
    if (value) {
      return value;
    }
    return 'en-us';
  },

  setLanguageCodeIdPreference(id, languageCodeId) {
    localStorage.setItem(id, languageCodeId);
  },
});
